var $ = require('jquery')
  , ShowPage = require('mobile/ui/showPage')
  , tmpl = require('./tmpl.handlebars')

$(function() {
  var section = $('.js-gallery')
  if (!section.length) { return }

  var showPage = new ShowPage();
  section.click(function() {
    var index = $(this).index('.js-gallery');
    showPage.show(tmpl(ued.gallery));
    new Swiper('.swiper-large-pic', {
      initialSlide : index,
      spaceBetween: '5%',
      pagination : $('.swiper-large-pic').find('.swiper-pagination'),
      paginationType : 'fraction',
      loop: true
    });
  })
})
